import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-cancel',
    templateUrl: './cancel.component.html',
    styleUrls: ['./cancel.component.css'],
    imports: [RouterLink]
})
export class CancelComponent implements OnInit {



  constructor() { }

  ngOnInit(): void {
   
  }

 
}
